import commonMixin from './../mixins/_common';
import flashMessageMixin from './../mixins/_flash_messages';
import canvaListMixin from './../mixins/_canva_list';

/**
 * バナーテンプレートリストコンポーネント
 */
export default {
    name: 'BannerTemplateList',
    template: '#banner_template_list_template',
    data() {
        return {
            // デザインをまとめて表示するか
            is_design_group: true,
        };
    },
    props: {
        // 画像選択から呼ばれているか
        is_select_mode: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    mixins: [
        commonMixin,
        flashMessageMixin,
        canvaListMixin,
    ],
    emits: ['banner-template-select'],
    methods: {
        // 画像のフルパスを取得する
        getFullImagePath: function (imagePath){
            return this.config.storage_path + '/' + imagePath;
        },
        // バナーテンプレート画像の選択を通知する
        emitSelectectBannerTemplate: function(imagePath) {
            // 画像選択モードでないならemitしない
            if (this.is_select_mode) {
                this.$emit('banner-template-select', imagePath);
            }
            return;
        },
        // 確認モーダルを開く
        modalOpenCanva: function(url) {
            this.$parent.$refs.modalOpenCanva.show(url);
        },
    },
};
